import { render } from "./cart_display.vue?vue&type=template&id=638423c8"
import script from "./cart_display.vue?vue&type=script&lang=js"
export * from "./cart_display.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__